var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2G(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00008 0.666748C4.40008 0.666748 0.666748 4.40008 0.666748 9.00008C0.666748 13.6001 4.40008 17.3334 9.00008 17.3334C13.6001 17.3334 17.3334 13.6001 17.3334 9.00008C17.3334 4.40008 13.6001 0.666748 9.00008 0.666748ZM10.1751 14.0751V15.6667H7.95008V14.0584C6.52508 13.7584 5.31675 12.8417 5.22508 11.2251H6.85842C6.94175 12.1001 7.54175 12.7834 9.06675 12.7834C10.7001 12.7834 11.0667 11.9667 11.0667 11.4584C11.0667 10.7667 10.7001 10.1167 8.84175 9.67508C6.77508 9.17508 5.35842 8.32508 5.35842 6.61675C5.35842 5.18342 6.51675 4.25008 7.95008 3.94175V2.33341H10.1751V3.95841C11.7251 4.33341 12.5001 5.50842 12.5501 6.78342H10.9167C10.8751 5.85842 10.3834 5.22508 9.06675 5.22508C7.81675 5.22508 7.06675 5.79175 7.06675 6.59175C7.06675 7.29175 7.60842 7.75008 9.29175 8.18342C10.9751 8.61675 12.7751 9.34175 12.7751 11.4417C12.7667 12.9667 11.6251 13.8001 10.1751 14.0751Z",
    fill: "#8B8B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2G);
export default __webpack_public_path__ + "static/media/icon2_g.94044187de1d85d456b7418bfe85d957.svg";
export { ForwardRef as ReactComponent };